<zef-dialog
  [open]="state.open"
  [options]="{ restoreFocus: false }"
  [autoFocus]="false"
  (closeTrigger)="onClose$.next()">
  <div class="__content  fx:relative">

    <zef-scrollbar maxHeight="80vh">

      <zui-form-section
        class="__form-section"
        separator="none">
        <span *zuiFormSectionTitle>Create Organization</span>

        <div *zuiFormSectionDesc>
          <span>Create your new organization. User can be part of multiple organizations.</span>
        </div>
      </zui-form-section>

      <div class="__integration-token-content">
        <zef-form
          #formRef
          class="fx:pt-1  fx:pb-1  fx:pl-1  fx:pr-1"
          [state]="state.formState"
          (submit)="onSubmit$.next()">

          <div class="__name-grid-item">
            <zef-form-field>
              <mat-form-field
                color="accent"
                class="__name-form-field">

                <mat-label>Organization Name</mat-label>

                <input
                  matInput
                  type="text"
                  [placeholder]="'Organization name'"
                  [ngrxFormControlState]="state.formState?.controls.name"
                  [ngrxEnableFocusTracking]="true"
                  class="__name-input"
                />

              </mat-form-field>
            </zef-form-field>
          </div>

        </zef-form>
      </div>

    </zef-scrollbar>

    <!-- Buttons Section -->
    <div class="__buttons">
      <div class="__buttons-grid">
        <div>
          <zef-progress-error
            full
            [key]="addClientKey">
            <button
              class="__button __primary-button c-button--full"
              color="accent"
              mat-flat-button
              type="button"
              (click)="formRef?.triggerSubmit()">
              Create Organization
            </button>
          </zef-progress-error>
        </div>

        <div>
          <button
            (click)="onClose$.next()"
            class="c-button--full"
            type="button"
            mat-button>
            <span transloco="general.close"></span>
          </button>
        </div>
      </div>
    </div>

  </div>
</zef-dialog>
